import { api } from './apiProvider';

export interface CompanyInfoResponse {
  name: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
  email: string;
  website: string;
  logoUrl: string;
}

export async function getCompanyInfo(): Promise<CompanyInfoResponse> {
  return await api.get('companies/current').json<CompanyInfoResponse>();
}
